export default __webpack_public_path__ + "static/media/GithubLogo.a4b35881.svg";